(ns ui.tailwind-theme
  (:require [reagent.core :as r]))

(def current-theme (r/atom "zapflow"))

(defn set-theme!
  [theme]
  (let [html (.querySelector js/document "html")]
    (js/console.log "Set tailwind theme : " theme)
    (reset! current-theme theme)
    (.setAttribute html "data-theme" theme)))
